<template>
  <div class="p-4 bg-white rounded-lg h-100" v-if="isDataLoaded">
    <IntegrationDataTable
      :table_state="table_state"
      :store_names="store_names"
      :addComponent="componentForAdding"
      :actionsComponent="componentForActions"
      :delete_url="delete_url"
      :urls="urls"
    >
      <template #actionsButton="{ selectedItems, refresher }">
        <div
          class="mr-md-2 mr-sm-1 mr-0 pa-0"
          :class="{ 'col-6 mx-8': $vuetify.breakpoint.xsOnly }"
        >
          <ActionsButton
            v-if="actionsButtonTypes.length > 0"
            :items="selectedItems"
            :types="actionsButtonTypes"
            :refresher="refresher"
            :class="{ 'col-6': $vuetify.breakpoint.xsOnly }"
          />
        </div>
      </template>
    </IntegrationDataTable>
  </div>
</template>

<script>
import IntegrationDataTable from "@/own/components/datahub/integrations2/IntegrationDataTable.vue";
import AddItem from "@/own/components/datahub/integrations2/CountriesConfigurations/AddItem.vue";
import ActionsButton from "@/own/components/datahub/integrations2/CountriesConfigurations/ActionsButton.vue";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import {
  EXPORT_TABLE_DATA,
  SET_TABLE_FILTER,
  SET_TABLE_PAGE,
  SET_TABLE_PER_PAGE,
  SET_TABLE_SORT_BY,
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_STRUCTURE,
} from "@/core/services/store/integrationCountries.module";
import DataTableActionSelectorNew from "@/own/components/DataTableActionSelectorNew.vue";

export default {
  name: "IntegrationCountries",
  props: ["integration"],
  components: { IntegrationDataTable, ActionsButton },
  data: () => ({
    componentForAdding: AddItem,
    componentForActions: DataTableActionSelectorNew,
    delete_url: `/validations/datahub/integration_countries/destroy`,
    table_state: {
      UPDATE_TABLE_STRUCTURE: UPDATE_TABLE_STRUCTURE,
      UPDATE_TABLE_DATA: UPDATE_TABLE_DATA,
      SET_TABLE_SORTBY: SET_TABLE_SORT_BY,
      SET_TABLE_FILTER: SET_TABLE_FILTER,
      SET_TABLE_PERPAGE: SET_TABLE_PER_PAGE,
      SET_TABLE_PAGE: SET_TABLE_PAGE,
      EXPORT_TABLE_DATA: EXPORT_TABLE_DATA,
    },
    store_names: {
      getTableFilters: "getINTEGRATIONCOUNTRIESTableFilters",
      getTableState: "getINTEGRATIONCOUNTRIESTableState",
      getTableData: "getINTEGRATIONCOUNTRIESTableData",
      getTableHeaders: "getINTEGRATIONCOUNTRIESTableHeaders",
      getTableProperties: "getINTEGRATIONCOUNTRIESTableProperties",
      getTableExportUrl: "getINTEGRATIONCOUNTRIESExportUrl",
      getTablePermissions: "getINTEGRATIONCOUNTRIESTablePermissions",
    },
    urls: {
      // status: `/order_management/subscriptions/status`,
      // delete: `/datahub/integration_order_status/destroy`,
    },
  }),
  methods: {
    async initTableContent() {
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_STRUCTURE, {
        integration_id: this.integration.id,
      });
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_DATA, {
        integration_id: this.integration.id,
      });
    },
    permissionChecker(permType) {
      let result = false;
      this.$store.getters[this.store_names.getTablePermissions].forEach(
        (element) => {
          if (element.name === permType) {
            result = true;
          }
        }
      );
      return result;
    },
  },
  computed: {
    actionsButtonTypes: function () {
      let types = [];

      const typeNames = ["Delete"];

      const typesUrl = ["destroy_bulk"];
      const typesPermission = ["bulkDestroy"];

      typesUrl.forEach((item, index) => {
        if (this.permissionChecker(typesPermission[index]))
          types.push({
            name: typeNames[index],
            url: item,
          });
      });

      return types;
    },
    isDataLoaded: function () {
      return this.$store.getters[this.store_names.getTableData];
    },
  },
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.initTableContent();
  },
};
</script>
